module.exports = "<!-- View/routes wrapper-->\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/layouts/blankLayout.template.html
// module id = ./src/app/components/common/layouts/blankLayout.template.html
// module chunks = main